
//There's a bug in Bootstrap since version 2 that prevents modals from showing on
//page load and looks like they are ignoring it
//https://github.com/twbs/bootstrap/issues/5891

$(function () {
    $(".modal[data-show=true]").each(function (idx, element) {
        $(element).modal();
    })
})